<template>
<div class="columns" style="padding: 10px;">
    <div class="column">
        <div class="field">
            <label class="label">Choose Class</label>
            <div class="control">
                <b-select id="kelasID" name="kelasID" v-model="input.kelasID">
                    <option selected value="0">Select the class</option>
                    <option v-for="kelas in kelasList" v-bind:value="kelas._id" v-bind:key="kelas._id">{{ kelas.level }} {{ kelas.name }}</option>
                </b-select>
            </div>
        </div>
        <div class="field">
            <label class="label">First Name</label>
            <div class="control">
                <input class="input" type="text" placeholder="E.g.: Bruce" v-model="input.firstName">
            </div>
       </div>
        <div class="field">
            <label class="label">Last Name</label>
            <div class="control">
                <input class="input" type="text" placeholder="E.g.: Wayne" v-model="input.lastName">
            </div>
       </div>
       <div class="field">
            <label class="label">Father's Name</label>
            <div class="control">
                <input class="input" type="text" placeholder="E.g.: Mother's Name" v-model="input.father">
            </div>
        </div>
        <div class="field">
            <label class="label">Father's ID</label>
            <div class="control">
                <input class="input" type="text" placeholder="E.g.: Mother's ID" v-model="input.fatherID">
            </div>
        </div>
        <div class="field">
            <label class="label">Mother's Name</label>
            <div class="control">
                <input class="input" type="text" placeholder="E.g.: Mother's Name" v-model="input.mother">
            </div>
       </div>
       <div class="field">
            <label class="label">Mother's ID</label>
            <div class="control">
                <input class="input" type="text" placeholder="E.g.: Mother's ID" v-model="input.motherID">
            </div>
        </div>
        <div class="field">
            <label class="label">Contact No #1</label>
            <div class="control">
                <input class="input" type="text" placeholder="E.g.: Telephone Number" v-model="input.contactNo1">
            </div>
       </div>
        <div class="field">
            <label class="label">&nbsp;</label>
                <div class='ui two buttons'>
                    <button class='button is-primary' v-on:click="sendForm()">Create</button>
                </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios'
import { ToastProgrammatic as Toast } from 'buefy'

export default {
    data() {
        return {
            input: {
                kelasID: '0',
                firstName: '',
                father: '',
                fatherID: '',
                mother: '',
                motherID: '',
                contactNo1: '',
                isCreating: false,
            },
            kelasList: [],
            result: "",
            errors: []
        };
    },
    beforeMount() {
        this.openForm()
    },
    created() {
        axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
        axios.post(process.env.MY_URL + '/api/auth/kelas/list', {
            params: {
                email: localStorage.getItem('email'),
                sessionID: localStorage.getItem('sessionID')
            }
        })
        .then(response => {
        // JSON responses are automatically parsed.
            this.kelasList = response.data
        })
        .catch(e => {
            this.errors.push(e)
            console.log(e)
        })
    },
    methods: {
        openForm() {
            this.input.isCreating = true;
        },
        closeForm() {
            this.input.isCreating = false;
        },
        sendForm() {
            console.log("imini 101")
            if (this.input.firstName.length > 0 && this.input.father.length > 0 && this.input.fatherID.length > 0) {
                const firstName = this.input.firstName;
                const lastName = this.input.lastName;
                this.$emit('students-create', {
                    firstName,
                    lastName,
                    done: false,
                });

                this.input.email = localStorage.getItem('email')
                this.input.sessionID = localStorage.getItem('sessionID')
                console.log("imini 109 email: " + localStorage.getItem('email'))
                console.log("imini 109 sessionID: " + localStorage.getItem('sessionID'))
                console.log("tokennn? " + localStorage.getItem('jwtToken'))
                console.log("imini input: ")
                console.log(this.input)

                axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
                axios.defaults.responseType = 'json'
                axios.post(process.env.MY_URL + '/api/students/add', this.input)

                    .then(response => {
                        console.log("145 response: ")
                        console.log(response)
                        if (response.data.success == false) {
                            Toast.open({
                                message: response.data.msg,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        } else {
                            Toast.open({
                                color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                message: "Student added successfully",
                                type: 'is-success',
                                duration: 3000
                            })
                            console.log("OK 157")
                            this.$parent.getStudents()
                        }

                        this.input.firstName = '';
                        this.input.lastName = '';
                        this.input.father = '';
                        this.input.fatherID = '';
                        this.input.mother = '';
                        this.input.motherID = '';
                        this.input.contactNo1 = '';
                        this.input.isCreating = false;
                    })
                    .catch(e => {
                        console.log("172?")
                        console.log(e)
                        if (e.response.status === 401) {
                            console.log("salah login")
                            this.errors.push("Invalid login")                            
                            alert("Unauthorized access. Please re-login.")
                        } else {
                            this.errors.push(e)
                        }
                    })
            } else {
                alert("Please at least enter the student's first name, father's name & ID.");
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Students/DataCreate.vue